export class ConfigsTokenGTO {

  constructor(
      public tokenExigido?: string,
      public tokenMensagem?: string,
      public tokenEnvioProcedimentos?: string,
  ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/configs-token-gto.ts